import React from 'react'
import "../../App.css"

const Products = () => {
    return (
        <div>
            <h1 className="products">PRODUCTS</h1>
        </div>
    )
}

export default Products
